export const TRACK_AMBASSADOR_SHOP = 'TRACK_AMBASSADOR_SHOP' as const;

export function trackAmbassadorShop(eventAction: string, eventLabel: string) {
  return {
    type: TRACK_AMBASSADOR_SHOP,
    eventAction,
    eventLabel,
  };
}
